<template lang="pug">
.hl
  .hlLeft
    Special(:link="link")
    HomeVideo(:video="video")
  .hlRight
    HomeNews(:tabs="tabData")
    RCard(:specialArticles="specialArticles")

</template>

<script>
import Special from '@/components/Special'
import HomeNews from '@/components/HomeNews'
import HomeVideo from '@/components/HomeVideo'
import RCard from '@/components/RCard'

export default {
  props: {
    link: {
      type: Array,
      default: []
    },
    video: {
      type: Object,
      default: null
    },
    tabData: {
      type: Array,
      default: []
    },
    specialArticles: {
      type: Array,
      default: []
    }
  },
  components: { Special, HomeNews, HomeVideo, RCard },

}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.hl
  width: 100%
  // min-height: 1000px
  +flexrow
  padding: 0 0 0 0
  // +bb
  .hlLeft
    width: 50%
    // +bb
  .hlRight
    width: 50%
    // +bb

</style>


// WEBPACK FOOTER //
// src/components/HomeLink.vue